import { combineReducers } from 'redux';

import { value } from './value';
import { options } from './options';
import { searchText } from './searchText';

export const countertop = combineReducers( {
  value,
  options,
  searchText
} );
